
import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, rpcCrudService } from "kea-resource";

const controller = rpcController("PartidaAclaracion");
const crud = rpcCrudService<models.PartidaAclaracion, models.PartidaAclaracionDTO>(controller);


export const PartidasAclaracion = cacheResource({
    ...crud,
    /**Obtiene todas las entidades filtradas por la zona */
    query: async (filtro?: models.FiltroPartidasAclaracion): Promise<models.PartidaAclaracion[]> =>  await controller("Query", {}, filtro || {}),
    /**Obtiene el total de todos los conceptos de la partida en aclaración */
    GetTotal: async (entity: models.PartidaAclaracion): Promise<number> => await controller("GetTotal", {}, entity),
    /**Obtiene los totales de guías en la partida en aclaración */
    GetTotalesGuia: async (entity: models.PartidaAclaracionGuiaDTO[]): Promise<number> => await controller("GetTotalesGuia", {}, entity),
    /**Obtiene los totales de facturas en la partida en aclaración */
    GetTotalesFactura: async (entity: models.PartidaAclaracionFacturaDTO[]): Promise<number> => await controller("GetTotalesFactura", {}, entity),
    /**Obtiene los totales de depositos en la partida en aclaración */
    GetTotalesDeposito: async (entity: models.PartidaAclaracionDepositoDTO[]): Promise<number> => await controller("GetTotalesDeposito", {}, entity),
}, {
    query: true,
}, {
    add: true,
    delete: true,
    update: true
});



// WEBPACK FOOTER //
// ./app/resources/items/partidaaclaracion.tsx